export default __webpack_public_path__ + "static/media/staking-icon.e0c346ec.svg";